<app-life-ins-headline [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-headline>
<div class="life-ins__content">
    <div nxRow>
        <div nxCol="12,12,12,4">
            <app-life-ins-date [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-date>
        </div>
        <div nxCol="12,12,12,4">
            <div class="check-label">
                <cpc-icon icon="check" [color]="'#70ad47'"></cpc-icon>
                {{ maInsuranceExtend.tariffDescShort }}
            </div>
        </div>
    </div>
</div>